import React from "react";

type Props = {
  size?: number;
  color?: string;
  className?: string;
};

const IconUnmute: React.FC<Props> = ({
  size = 32,
  color = "#3E3851",
  className = "fill-neutral-60",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M8.0013 9.99935C8.70855 9.99935 9.38682 9.7184 9.88692 9.2183C10.387 8.7182 10.668 8.03993 10.668 7.33268V3.33268C10.668 2.62544 10.387 1.94716 9.88692 1.44706C9.38682 0.946967 8.70855 0.666016 8.0013 0.666016C7.29406 0.666016 6.61578 0.946967 6.11568 1.44706C5.61559 1.94716 5.33464 2.62544 5.33464 3.33268V7.33268C5.33464 8.03993 5.61559 8.7182 6.11568 9.2183C6.61578 9.7184 7.29406 9.99935 8.0013 9.99935ZM6.66797 3.33268C6.66797 2.97906 6.80844 2.63992 7.05849 2.38987C7.30854 2.13982 7.64768 1.99935 8.0013 1.99935C8.35492 1.99935 8.69406 2.13982 8.94411 2.38987C9.19416 2.63992 9.33464 2.97906 9.33463 3.33268V7.33268C9.33463 7.6863 9.19416 8.02544 8.94411 8.27549C8.69406 8.52554 8.35492 8.66602 8.0013 8.66602C7.64768 8.66602 7.30854 8.52554 7.05849 8.27549C6.80844 8.02544 6.66797 7.6863 6.66797 7.33268V3.33268ZM13.3346 7.33268C13.3346 7.15587 13.2644 6.9863 13.1394 6.86128C13.0143 6.73625 12.8448 6.66602 12.668 6.66602C12.4912 6.66602 12.3216 6.73625 12.1966 6.86128C12.0715 6.9863 12.0013 7.15587 12.0013 7.33268C12.0013 8.39355 11.5799 9.41096 10.8297 10.1611C10.0796 10.9113 9.06217 11.3327 8.0013 11.3327C6.94044 11.3327 5.92302 10.9113 5.17287 10.1611C4.42273 9.41096 4.0013 8.39355 4.0013 7.33268C4.0013 7.15587 3.93106 6.9863 3.80604 6.86128C3.68102 6.73625 3.51145 6.66602 3.33464 6.66602C3.15782 6.66602 2.98826 6.73625 2.86323 6.86128C2.73821 6.9863 2.66797 7.15587 2.66797 7.33268C2.66915 8.63088 3.14378 9.88407 4.0029 10.8573C4.86202 11.8306 6.04662 12.4571 7.33464 12.6193V13.9993H6.0013C5.82449 13.9993 5.65492 14.0696 5.5299 14.1946C5.40487 14.3196 5.33464 14.4892 5.33464 14.666C5.33464 14.8428 5.40487 15.0124 5.5299 15.1374C5.65492 15.2624 5.82449 15.3327 6.0013 15.3327H10.0013C10.1781 15.3327 10.3477 15.2624 10.4727 15.1374C10.5977 15.0124 10.668 14.8428 10.668 14.666C10.668 14.4892 10.5977 14.3196 10.4727 14.1946C10.3477 14.0696 10.1781 13.9993 10.0013 13.9993H8.66797V12.6193C9.95598 12.4571 11.1406 11.8306 11.9997 10.8573C12.8588 9.88407 13.3335 8.63088 13.3346 7.33268Z"
        fill={color}
      />
    </svg>
  );
};

export default IconUnmute;
